/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
// BE grid metadata supplies the purchase-date row action for the receive-note
// and delivery-note item grids. These strings must match what the grid
// emits/returns; confirmed against the live opening-balance notes.
export const SET_PURCHASE_DATE_ACTION_KEY = 'editPurchaseDate';
export const PURCHASE_DATE_ROW_COLUMN = 'purchaseDate';
